export default __webpack_public_path__ + "static/no-image-b9173ea8d63104595630e1a4f06f8faa.jpg";